import { SafetyLocalStorage } from '@mail-core/std';
import { differenceInDays, startOfDay } from 'date-fns';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { freemiumEndingBanners, isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';

const FREEMIUM_EXPIRES_DATE_KEY = 'freemium_expires_date';
const lStorage = new SafetyLocalStorage({});
const email = USER_EMAIL;

export enum FreemiumBannerState {
    NONE = 'none',
    ENDING = 'ending',
    ENDED = 'ended',
}

export const shouldShowEndingBanner = (freemiumDays: number): boolean => {
    if (!freemiumEndingBanners) {
        return false;
    }

    if (!isSoftFreemium && !isHardFreemium) {
        return false;
    }

    return freemiumDays <= 3 && freemiumDays > 0;
};

export const saveFreemiumExpiresDate = (expiresDate: number | null): void => {
    if (expiresDate) {
        lStorage.setItem(`${email}|${FREEMIUM_EXPIRES_DATE_KEY}`, expiresDate.toString());
    }
};

export const getFreemiumExpiresDateFromStorage = (): number | null => {
    const saved = lStorage.getItem(`${email}|${FREEMIUM_EXPIRES_DATE_KEY}`);
    if (saved) {
        const date = Number(saved);
        if (!isNaN(date)) {
            return date;
        }
    }
    return null;
};

export const shouldShowEndedBanner = (freemiumDays: number, expiresDate: number | null): boolean => {
    if (!freemiumEndingBanners) {
        return false;
    }

    if (!isSoftFreemium && !isHardFreemium) {
        return false;
    }

    let actualExpiresDate = expiresDate;
    if (!actualExpiresDate) {
        actualExpiresDate = getFreemiumExpiresDateFromStorage();
    }

    if (!actualExpiresDate) {
        return false;
    }

    if (freemiumDays > 0) {
        return false;
    }

    const today = startOfDay(new Date());
    const expiresDay = startOfDay(actualExpiresDate);
    const daysSinceExpiry = differenceInDays(today, expiresDay);

    return daysSinceExpiry >= 0 && daysSinceExpiry <= 7;
};

export const getFreemiumBannerState = (freemiumDays: number, expiresDate: number | null): FreemiumBannerState => {
    let actualExpiresDate = expiresDate;
    if (!actualExpiresDate) {
        actualExpiresDate = getFreemiumExpiresDateFromStorage();
    }

    if (shouldShowEndedBanner(freemiumDays, actualExpiresDate)) {
        return FreemiumBannerState.ENDED;
    }

    if (shouldShowEndingBanner(freemiumDays)) {
        return FreemiumBannerState.ENDING;
    }

    return FreemiumBannerState.NONE;
};
